"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _sources = require("@studio/sources");
var _program = require("@studio/program");
var _constants = require("@studio/constants");
var _setSceneLayout = _interopRequireDefault(require("./setSceneLayout"));
var _queueStageLayout = _interopRequireDefault(require("./queueStageLayout"));
var _sources2 = require("../../utils/sources");
var _sendToDatadogWithIds = require("../../utils/sendToDatadogWithIds");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * Since `setProgram` will be different in .lite and .pro,
 * this action will accept `setProgram`
 * as a parameter and dispatch it.
 * @param {{}} layout
 * @param {boolean} retainLiveCameraSources
 * @param {Function} setProgram  Action be passed from director
 * @param {Function} updateSource  Action be passed from director
 */
function selectLayout(layout, retainLiveCameraSources, setProgram, updateSource, endHostChangesStageLayout) {
  return function (dispatch, getState) {
    var _getState = getState(),
      banners = _getState.banners,
      program = _getState.program,
      sceneLayers = _getState.sceneLayers,
      liveSources = _getState.liveSources,
      serverTimeDelta = _getState.serverTimeDelta,
      featuredPresenter = _getState.featuredPresenter,
      attendeeMuteStatus = _getState.attendeeMuteStatus,
      dragAndDrop = _getState.broadcastSettings.dragAndDrop,
      stagedSources = _getState.stagedSources.sources,
      broadcastSources = _getState.broadcastSources.sources,
      brandingSettings = _getState.brandingSettings;
    var isStaged = Object.keys(stagedSources).reduce(function (acc, sId) {
      return acc || stagedSources[sId];
    }, false);
    if (isStaged) {
      return dispatch((0, _queueStageLayout["default"])(layout));
    }
    var programSources = program.layers.map(function (layerSource) {
      return layerSource.source;
    });
    var sourcesWithOnlyLiveCameras = programSources.filter(function (source) {
      if (source.type === _constants.CAMERA_PRESENTER && !liveSources.includes(source._id)) return false;
      return true;
    });
    var newSources = retainLiveCameraSources ? sourcesWithOnlyLiveCameras : programSources;
    var sources = addFeaturedPresenter(newSources, featuredPresenter);
    var combinedLayers = [].concat(_toConsumableArray(sceneLayers), _toConsumableArray(banners));
    var sceneSources = dragAndDrop ? (0, _sources2.orderSources)(sources) : sources;
    var resetSources = (0, _sources.resetNotLiveVideoSource)(liveSources, sceneSources, serverTimeDelta, dispatch, updateSource);
    var withAudioPresenterSources = (0, _sources.attachAudioPresenterSources)(resetSources, attendeeMuteStatus);
    var scene = (0, _program.sceneBuilder)(layout, withAudioPresenterSources, combinedLayers, {}, {}, brandingSettings === null || brandingSettings === void 0 ? void 0 : brandingSettings.fonts);
    scene.style = program.style;

    /**
     * Check if there is any live audio source
     * before transferring it to the newly built scene.
     */
    var liveAudioSource = broadcastSources.filter(function (source) {
      return source.type === _constants.AUDIO_FILE;
    }).map(function (audioSource) {
      return audioSource._id;
    }).some(function (audioSourceId) {
      return liveSources.includes(audioSourceId);
    });
    var newScene = liveAudioSource ? (0, _sources2.transferAudioSourceLayer)(program, scene) : scene;
    if (setProgram && typeof setProgram === 'function') {
      dispatch(setProgram(newScene, false, {
        emitSocket: true
      }, endHostChangesStageLayout));
      (0, _sendToDatadogWithIds.logProgramChange)(getState, 'selectLayout action');
    }
    dispatch((0, _setSceneLayout["default"])(layout));
  };
}

/**
 * @param {Array} sources
 * @param {string} featuredPresenterId
 */
function addFeaturedPresenter(sources, featuredPresenterId) {
  return sources === null || sources === void 0 ? void 0 : sources.map(function (source) {
    return _objectSpread(_objectSpread({}, source), {}, {
      featured: source.type === _constants.CAMERA_PRESENTER && source._id === featuredPresenterId
    });
  });
}
var _default = exports["default"] = selectLayout;